import { Alert, Button, Group, List, Modal, Stack, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { primaryColor } from '../../constants/theme';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useState } from 'react';
import { StripeIFrameWrapper } from '../../pages/new/components/profile/StripeIFrameWrapper';
import { useApp } from '../../context/AppContext';

export const StipeSetupErrorModal = () => {
  const { setStripeSetupIssues, stripeSetupIssues } = useApp();
  const [opened, { close }] = useDisclosure(stripeSetupIssues);
  const [isStripeStep, setIsStripeStep] = useState(false);

  const onLater = () => {
    setStripeSetupIssues(false);
    close();
  };

  const onClose = () => {
    console.log('closing stripe modal');
    setStripeSetupIssues(false);
    close();
  };

  const modalStep = () => {
    if (isStripeStep) {
      return <StripeIFrameWrapper onClose={onClose} />;
    }
    return (
      <StripeWarningMessage
        onLater={onLater}
        onNext={() => setIsStripeStep(true)}
      />
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      withCloseButton={false}
      closeOnClickOutside={false}
      centered
    >
      <Stack gap={10}>{modalStep()}</Stack>
    </Modal>
  );
};

const StripeWarningMessage = ({
  onLater,
  onNext,
}: {
  onLater: () => void;
  onNext: () => void;
}) => {
  return (
    <>
      <Title order={3} fw="normal" ta="center">
        Stripe Setup Issues
      </Title>
      <Stack gap={5}>
        <Group justify="center" w={'100%'}>
          <IconAlertTriangle color={primaryColor} size={50}></IconAlertTriangle>
        </Group>
        <Title order={5} fw="normal" ta="center" c="dimmed">
          Stripe has requested some additional information to ensure your
          account is compliant with regional rules and regulations
        </Title>
        <Alert title="Important Information" color={primaryColor}>
          <List>
            <List.Item>
              Booking will be disabled until you complete the required
              information
            </List.Item>
            <List.Item>
              Once you have updated your stripe account bookings will be enabled
              again
            </List.Item>
          </List>
        </Alert>
      </Stack>
      <Group align="center" justify="center">
        <Button
          variant="outline"
          w="47%"
          color={primaryColor}
          onClick={onLater}
        >
          I'll do it later
        </Button>
        <Button color={primaryColor} w="47%" onClick={onNext}>
          Update Stripe
        </Button>
      </Group>
    </>
  );
};
